import { Button } from "react-bootstrap";
import { X } from "lucide-react";
import "./popup.css";
export const DeletePopup = ({
  imgPopup,
  title,
  textBtn,
  textBtn1,
  closePopup,
  funToDelete,
}) => {
  return (
    <div className="popup-overlay">
      <div onClick={closePopup} className="close">
        <X />
      </div>
      <div className="popup-content">
        {imgPopup}
        <h3 style={{ textAlign: "center" }}>{title}</h3>

        <div className="poupop-group-btns">
          <Button className="default-btn" onClick={funToDelete}>
            {textBtn}
          </Button>
          {textBtn1 && (
            <Button className="other-btn-delete" onClick={closePopup}>
              {textBtn1}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
